import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';
import './Unsubscribe.css';

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  // Extract keys from the URL
  const uid = searchParams.get('uid');
  const token = searchParams.get('token');

  const handleUnsubscribe = async () => {
    if (!uid || !token) {
      setStatus('error');
      setMessage('Invalid link. Please contact support.');
      return;
    }

    setStatus('loading');
    
    try {
      const functions = getFunctions();
      const unsubscribeFn = httpsCallable(functions, 'unsubscribe');
      
      // Call the cloud function
      await unsubscribeFn({ uid, token });
      
      setStatus('success');
      setMessage('You have been successfully unsubscribed.');
    } catch (error) {
      console.error("Unsubscribe error:", error);
      setStatus('error');
      setMessage(error.message || 'An error occurred. You may already be unsubscribed.');
    }
  };

  return (
    <div className="unsubscribe-container">
      <div className="unsubscribe-card">
        <h2>Email Preferences</h2>
        
        {status === 'idle' && (
          <>
            <p>Are you sure you want to stop receiving updates from AiPredict?</p>
            <button onClick={handleUnsubscribe} className="btn-confirm">
              Confirm Unsubscribe
            </button>
            <Link to="/" className="btn-cancel">Cancel</Link>
          </>
        )}

        {status === 'loading' && (
          <div className="loading-spinner">Processing request...</div>
        )}

        {status === 'success' && (
          <div className="success-message">
            <span className="icon">✅</span>
            <p>{message}</p>
            <Link to="/" className="btn-home">Return to Home</Link>
          </div>
        )}

        {status === 'error' && (
          <div className="error-message">
            <span className="icon">⚠️</span>
            <p>{message}</p>
            <Link to="/support" className="btn-support">Contact Support</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;